// extracted by mini-css-extract-plugin
module.exports = {"inputsList":"ValueInputs_inputsList__13ocd","inputRow":"ValueInputs_inputRow__2sPdx","inputHeading":"ValueInputs_inputHeading__1Qg_w"};